import React from "react";

interface AddButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const AddButton: React.FC<AddButtonProps> = ({ onClick, disabled }) => (
  <div className="add-part-button">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      onClick={disabled ? undefined : onClick}
      style={{
        pointerEvents: disabled ? "none" : "auto",
        opacity: disabled ? 0.2 : 1,
        cursor: disabled ? "not-allowed" : "pointer"
      }}
      role="button"
      className="add-button-cursor"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM11.8982 7.00685L12 7C12.3797 7 12.6935 7.28215 12.7432 7.64823L12.75 7.75V11.25H16.25C16.6297 11.25 16.9435 11.5322 16.9932 11.8982L17 12C17 12.3797 16.7178 12.6935 16.3518 12.7432L16.25 12.75H12.75V16.25C12.75 16.6297 12.4678 16.9435 12.1018 16.9932L12 17C11.6203 17 11.3065 16.7178 11.2568 16.3518L11.25 16.25V12.75H7.75C7.3703 12.75 7.05651 12.4678 7.00685 12.1018L7 12C7 11.6203 7.28215 11.3065 7.64823 11.2568L7.75 11.25H11.25V7.75C11.25 7.3703 11.5322 7.05651 11.8982 7.00685L12 7L11.8982 7.00685Z"
        fill="#0074CA"
      />
    </svg>
  </div>
);

export default AddButton;
